import { render, staticRenderFns } from "./chateau-malescasse.vue?vue&type=template&id=09a50172&scoped=true"
import script from "./chateau-malescasse.vue?vue&type=script&lang=js"
export * from "./chateau-malescasse.vue?vue&type=script&lang=js"
import style0 from "./chateau-malescasse.vue?vue&type=style&index=0&id=09a50172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a50172",
  null
  
)

export default component.exports